import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController } from 'ionic-angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConstsProvider } from '../../../../providers/retirement-tools/consts/consts';

@IonicPage()
@Component({
  selector: 'page-add-expense',
  templateUrl: 'add-expense.html',
})
export class AddExpensePage {
  public otherExpense: boolean = false;
  public item = { label: 'Alimentación en casa (súper, abarrotes y productos de consumo)', type: 'Necesario', value: { today: 1000, retirement: 500 }, otherExpense: false };
  myForm: FormGroup;
  public gastos: Array<string>;

  constructor(public navCtrl: NavController, public Const: ConstsProvider, public viewCtrl: ViewController, public navParams: NavParams, public formBuilder: FormBuilder) {
    this.gastos = Const.gastos;
    this.myForm = this.formBuilder.group({
      label: [navParams.get('label') ? navParams.get('label') : '', [Validators.required]],
      type: [navParams.get('type') ? navParams.get('type') : 'Necesario', [Validators.required]],
      today: [navParams.get('value') && navParams.get('value').today ? navParams.get('value').today : 1000, [Validators.required, Validators.min(0)]],
      retirement: [navParams.get('value') && navParams.get('value').retirement ? navParams.get('value').retirement : 500, [Validators.required, Validators.min(0)]],
      otherExpense: [navParams.get('otherExpense') ? navParams.get('otherExpense') : false, [Validators.required]]
    });
  }

  ionViewDidLoad() {
  }

  close() {
    this.viewCtrl.dismiss();
  }

  addExpense() {
    this.item.label = this.myForm.get('label').value;
    this.item.type = this.myForm.get('type').value;
    this.item.value.retirement = this.myForm.get('retirement').value;
    this.item.value.today = this.myForm.get('today').value;
    this.item.otherExpense = this.myForm.get('otherExpense').value;
    this.viewCtrl.dismiss({ data: this.item, type: this.navParams.get('label') ? 'update' : 'save' });
  }

  guardar() {
    this.viewCtrl.dismiss({ data: this.item });
  }

  change(ev) {
    if (ev.checked) {
      this.myForm.get('label').setValue('');
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/retirement-tools/retirement-calculator/add-expense/add-expense.ts